import { getUserProfileData } from '~/api/profile';
import { canUseDOM } from '@academysports/utils-lib/src/executionEnvironment';
import Storage from './StorageManager';
import { USER_PROFILE_DATA } from './constants';

export const enableMetaTracking = () => {
  if (canUseDOM) {
    return window.ASOData?.uiConfig?.cmsGlobal?.ENABLE_META_TRACKING;
  }
  return false;
};

// Stores user profile data into local storage
export const profileDataHandler = (setProfileDataFetchStart, setProfileDataUpdateState) => {
  const metaTrackingFlag = enableMetaTracking();
  if (metaTrackingFlag) {
    if (typeof setProfileDataFetchStart === 'function') {
      setProfileDataFetchStart();
    }
    getUserProfileData()
      .then(response => {
        if (response && response?.data) {
          const userData = response?.data;
          Storage.setLocalStorage(USER_PROFILE_DATA, userData);
          if (typeof setProfileDataUpdateState === 'function') {
            setProfileDataUpdateState(userData);
          }
        }
      })
      .catch(err => {
        console.log(err);
      });
  }
};
